import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { Router, RouterOutlet } from '@angular/router';

import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import { AuthService } from './shared/services/auth/auth.service';
import { LoadingService } from './shared/services/loading/loading.service';
import { LoadingComponent } from './shared/components/loading/loading.component';
import { GOOGLE } from 'src/assets/icons/google-icon';
import { FYND } from 'src/assets/icons/fynd-icon';
import { FYND_WHITE } from 'src/assets/icons/fynd-icon-white';
import { MaterialModule } from './shared/material.module';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, LoadingComponent],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',

  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AppComponent {
  title = 'fynd';
  protected readonly isGlobalLoading = inject(LoadingService).loading;

  constructor(
    iconRegistry: MatIconRegistry,
    domSanitizer: DomSanitizer,
    readonly authService: AuthService,
    readonly router: Router,
    readonly loadingService: LoadingService,
  ) {
    if (typeof sessionStorage !== 'undefined' && sessionStorage.getItem('justLoggedOut')) {
      sessionStorage.removeItem('justLoggedOut');
      this.router.navigate(['/login']);
    }

    iconRegistry
      .addSvgIconLiteral('google', domSanitizer.bypassSecurityTrustHtml(GOOGLE))
      .addSvgIconLiteral('fynd', domSanitizer.bypassSecurityTrustHtml(FYND))
      .addSvgIconLiteral('fynd-white', domSanitizer.bypassSecurityTrustHtml(FYND_WHITE));
  }
}
